import { createFileRoute } from "@tanstack/react-router";
import { ComprovanteDetalhePage } from "@/pages/ComprovanteDetalhePage";

export const Route = createFileRoute("/comprovantes/$id")({
  head: () => ({
    meta: [{ title: "Detalhe do Comprovante — AXIS Comprovantes" }],
  }),
  component: ComprovanteDetalhePage,
});
